import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { message, Popover } from "antd";
import { HeartOutlined, HeartFilled } from "@ant-design/icons";

import { setSigninModalIsOpen } from "store/slices/layoutSlice";
import { addToWishlist, deleteFromWishlist } from "store/slices/customerSlice";
import useCustomer from "hooks/useCustomer";
import Icon from "components/Icon";

const WishlistButton = ({
  product_id,
  active = false,
  size = 26,
  wrapStyle = {},
  actionAfterDelete = () => {},
  useSvgIcon = false,
  iconClassName = "",
}) => {
  const [isActive, setIsActive] = useState(active);
  const dispatch = useDispatch();
  const { customer } = useCustomer();

  // Синхронизируем с внешним пропсом active
  useEffect(() => {
    setIsActive(active);
  }, [active]);

  const handleAddToWishlist = async () => {
    if (customer.token) {
      const res = await addToWishlist(product_id);
      if (res?.success) message.success(res.success);
      // В любом случае обновляем локальное состояние, чтобы сразу отобразить изменение
        setIsActive(true);
    } else {
      dispatch(setSigninModalIsOpen(true));
    }
  };

  const handleDeleteFromWishlist = async () => {
    if (customer.token) {
      const res = await deleteFromWishlist(product_id);
      if (res?.success) message.warning(res.success);
      // В любом случае обновляем локальное состояние, чтобы сразу отобразить изменение
        setIsActive(false);
        actionAfterDelete();
    } else {
      dispatch(setSigninModalIsOpen(true));
    }
  };

  const content = isActive ? "Удалить из избранного" : "Добавить в избранное";
  const action = isActive ? handleDeleteFromWishlist : handleAddToWishlist;

  // Вариант с SVG иконками (для страницы товара и корзины)
  const popoverStyle = {
    padding: "6px 8px",
    fontSize: 12,
    lineHeight: "16px",
    whiteSpace: "nowrap",
  };

  if (useSvgIcon) {
    return (
      <Popover content={content} overlayInnerStyle={popoverStyle}>
        <div
          className={iconClassName}
          style={{ cursor: "pointer", ...wrapStyle }}
          onClick={action}
        >
          <Icon
            name={isActive ? "icon-heart-filled" : "icon-heart"}
            ariaLabel="Избранное"
            width={size}
            height={size}
          />
        </div>
      </Popover>
    );
  }

  return (
    <div
      className={`wishlist-buttons ${isActive ? "wishlist-active" : ""}`}
      style={wrapStyle}
    >
      <HeartOutlined
        className="wishlist-notactive-icon"
        style={{ fontSize: size, color: "red" }}
        onClick={handleAddToWishlist}
      />
      <Popover
        content={content}
        className="wishlist-active-icon"
        overlayInnerStyle={popoverStyle}
      >
        <HeartFilled
          style={{ fontSize: size, color: "red" }}
          onClick={action}
        />
      </Popover>
    </div>
  );
};

export default WishlistButton;
